"use strict";

exports.__esModule = true;
var transformPractice = exports.transformPractice = function transformPractice(practice) {
	return practice && {
		name: practice.name,
		id: practice.id,
		averageReviews: parseFloat(practice.average_review || 0),
		numberOfReviews: parseFloat(practice.number_of_reviews || 0),
		cover: practice.attributes && practice.attributes.profile_cover + "_lg.jpg",
		featuredImage: practice.attributes && practice.attributes.profile_logo && practice.attributes.profile_logo + "_lg.jpg" || null
	};
};